export default {
  adearch: 'Ad search',
  ads: 'Ads',
  areaWidgetsUpdated: 'Area widgets updated.',
  articles: 'Articles',
  articleSearch: 'Article search',
  ascending: 'Ascending',
  authenticated: 'Only authenticated',
  availability: 'Availability',
  brand: 'Brand',
  color: 'Color',
  count: 'Count',
  promotion: 'Promotion',
  milliseconds: 'milliseconds',
  descending: 'Descending',
  everyone: 'Everyone',
  filter: 'Filter',
  icon: 'Icon',
  imageHeight: 'Image Height',
  images: 'Images',
  imageWidth: 'Image Width',
  impression: 'Impression',
  interval: 'Interval',
  item: 'Item',
  items: 'Items',
  link: 'Link',
  menu: 'Menu',
  mostVisited: 'Most visited',
  nav: 'Nav',
  networks: {
    instagram: 'Instagram',
    telegram: 'Telegram',
    twitter: 'Twitter'
  },
  newest: 'Newest',
  newPage: 'New Page',
  order: 'Order by',
  post: 'Post',
  price: 'Price',
  priceAfterDiscountMax: 'Price After Discount Max',
  priceAfterDiscountMin: 'Price After Discount Min',
  product: 'Product',
  productSort: 'Product Sort',
  providers: 'Providers',
  providerSearch: 'Provider search',
  sales: 'Sales',
  samePage: 'Same Page',
  share: 'Share',
  showImage: 'Show Image',
  showPrice: 'Show Price',
  showTitle: 'show Title',
  slider: 'Slider',
  social: 'Social networks',
  sort: 'Sort',
  sortType: 'Sort Type',
  speed: 'Speed',
  subtitle: 'Subtitle',
  tags: 'Tags',
  target: 'Open In',
  text: 'Text',
  unauthenticated: 'Only unauthenticated',
  url: 'More Url',
  viewData: 'View Data',
  viewName: 'View Name',
  widgetAvailability: 'availability',
  widgetType: 'Widget',
  component: 'Component',
  componentName: 'Component name',
  form: 'Form',
  type: 'Type',
  attribute: 'Attribute',
  data: 'Data',
  formInputs: 'Form inputs',
  restUrl: 'Rest url',
  payAttentionToTheDetailsOn_widget:
    'Pay attention to the details on {widget} widget',
  restMethod: 'Rest method',
  successMessage: 'Success message',
  failureMessage: 'Failure message',
  singleSection: 'Single section',
  twoSection: 'Two section',
  threeSection: 'Three section',
  fourSection: 'Four section',
  baseAttributes: 'Base attributes',
  seoAttributes: 'SEO attributes',
  paging: 'Paging',
  firstSection: 'First section',
  secondSection: 'Second section',
  thirdSection: 'Third section',
  forthSection: 'Forth section',
  testimonial: 'Testimonial',
  profession: 'Profession',
  userImage: 'User image',
  section: 'Section',
  accordion: 'Accordion',
  componentNames: {
    account: 'Account area',
    download: 'Download',
    introduction: 'Seassional banner',
    featuresSlider: 'Features slider',
    workflow: 'Workflow',
    sidebarToggle: 'Sidebar toggle',
    contactUsForm: 'Contact-us form',
    contactUsAddress: 'Contact info',
    buisnessDescription: 'Buisness description'
  },
  formItemNames: {
    text: 'Text',
    checkbox: 'Check box',
    textarea: 'Textarea',
    radio: 'Radio button',
    dropdown: 'Dropdown',
    link: 'Link',
    submit: 'Submit button'
  },
  displaySettings: 'Display settings',
  areaDisplaySettings: 'Area display settings',
  pageDisplaySettings: 'Page display settings',
  fullScreen: 'Full screen',
  downloadLinks: 'Download links',
  downloadQRCode: 'QR code',
  seasons: {
    spring: 'Spring',
    summer: 'Summer',
    fall: 'Fall',
    winter: 'Winter'
  },
  pwa: 'PWA'
}
